"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeAngle = exports.TWO_PI = void 0;
const core_api_1 = require("@ikegps/core-api");
/** 2 * Math.Pi */
exports.TWO_PI = Math.PI * 2;
/** Utility to help with working with angles */
class IkeAngle {
    /**
     * Case sensitive search for unit type
     * @see IkeAngle.toUnitAngle
     */
    static isUnitAngle(unit) {
        return unit === IkeAngle.RADIAN || unit === IkeAngle.DEGREE;
    }
    /** Case insensitive angle unit type search */
    static toUnitAngle(unit) {
        let searchUnit = unit.toLowerCase();
        if (IkeAngle.isUnitAngle(searchUnit)) {
            return searchUnit;
        }
        return null;
    }
    /**
     * Convert an angle to be between 0 and 2 * pi
     * @param value Angle (Radians)
     */
    static normalize(value) {
        return (value + exports.TWO_PI) % exports.TWO_PI;
    }
    /**
     * Rotate an angle by pi
     * @param value Angle (Radians)
     */
    static flip(value) {
        return (value + Math.PI) % exports.TWO_PI;
    }
    /**
     * Convert an angle from degrees to radians
     * @param degrees Angle (Degrees)
     */
    static toRadians(degrees) {
        return degrees * (Math.PI / 180);
    }
    /**
     * Convert an angle from radian to degrees
     * @param radians Angle (Radians)
     */
    static toDegrees(radians) {
        return radians * (180 / Math.PI);
    }
}
exports.IkeAngle = IkeAngle;
IkeAngle.RADIAN = core_api_1.IkeUnitAngle.RADIAN;
IkeAngle.DEGREE = core_api_1.IkeUnitAngle.DEGREE;
//# sourceMappingURL=angle.js.map